export var GitRepositorySortField;
(function (GitRepositorySortField) {
    GitRepositorySortField["GIT_REPOSITORY_SORT_FIELD_CREATED_AT"] = "createdAt";
    GitRepositorySortField["GIT_REPOSITORY_SORT_FIELD_UPDATED_AT"] = "updatedAt";
    GitRepositorySortField["GIT_REPOSITORY_SORT_FIELD_FULL_NAME"] = "fullName";
    GitRepositorySortField["GIT_REPOSITORY_SORT_FIELD_STATUS"] = "status";
})(GitRepositorySortField || (GitRepositorySortField = {}));
